import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
  IconList,
  IconListItem,
  Text,
  Title,
} from '@folio/components';
import { CustomIncludedPerilsProps } from 'korint-sdk';
import { CheckIcon } from 'lucide-react';
import { useState } from 'react';

export function IncludedPerilsAssistance({ tier }: CustomIncludedPerilsProps) {
  const [open, setOpen] = useState(false);

  const basicGuarantees = [
    {
      title: 'Dépannage/Remorquage',
      details: [
        '300€ vers le garage de la marque le plus proche ou à défaut, le garage le plus proche',
        'Remorquage à la borne électrique la plus proche',
      ],
    },
    {
      title: 'Véhicule de remplacement',
      details: [
        "Si plus de 4H de main d'œuvre ou 48H d'immobilisation",
        'Catégorie EDMR',
        "10 jours en cas d'accident",
        '30 jours en cas de vol',
      ],
    },
  ];

  const premiumGuarantees = [
    {
      title: 'Dépannage/Remorquage',
      details: ['Sans plafond', 'Remorquage à la borne électrique la plus proche'],
    },
    {
      title: 'Véhicule de remplacement',
      details: [
        "Si plus de 4H de main d'œuvre ou 24H d'immobilisation",
        "Catégorie équivalente jusqu'à monospace, SUV",
        '10 jours en cas de panne',
        "10 jours en cas d'accident",
        '45 jours en cas de vol',
      ],
    },
  ];

  const commonGuarantees = [
    "Panne d'un Véhicule sous garantie constructeur",
    'Attente des réparations si véhicule non réparé dans la journée',
    'Poursuite ou retour au domicile si le véhicule immobilisé plus de 24H en France et plus de 72H à l’Etranger',
    'Récupération du Véhicule',
    "Envoi de pièces détachées à l'étranger",
    "Rapatriement du Véhicule depuis l'étranger",
    "Abandon du Véhicule à l'étranger",
    "Frais de gardiennage à l'étranger",
    'Frais de liaison',
    'Aide à la rédaction du constat amiable',
    'Rapatriement médical',
    'Visite d’un proche',
    'Envoi d’un médecin auprès d’un assuré à l’étranger',
    'Rapatriement en cas de décès',
    'Présence d’un proche en cas de décès',
    'Envoi de médicament à l’étranger',
    'Chauffeur de remplacement',
    'Soutien psychologique',
    'Garantie des frais d’hospitalisation',
    'Avance de caution pénale',
    'Honoraires d’avocat',
  ];

  return (
    <IconList icon={<CheckIcon className="size-5 text-green-600" />} gap={6} className="text-sm">
      {(tier === 'PREMIUM' ? premiumGuarantees : basicGuarantees).map(guarantee => (
        <IconListItem key={guarantee.title}>
          <Title order={4} className="mb-2">
            {guarantee.title}
          </Title>
          {guarantee.details.map((detail, index) => (
            <Text key={`basic-${guarantee.title}-${index}`} className="leading-relaxed">
              {guarantee.details.length > 1 ? '•' : ''} {detail}
            </Text>
          ))}
        </IconListItem>
      ))}
      <IconListItem>
        <Collapsible open={open} onOpenChange={setOpen}>
          <Title order={4}>Garanties communes</Title>
          <CollapsibleTrigger asChild>
            <Text className="leading-relaxed hover:underline cursor-pointer">
              {open ? '- Masquer' : '+ Voir'} les 21 garanties communes incluses
            </Text>
          </CollapsibleTrigger>
          <CollapsibleContent>
            {commonGuarantees.map((guarantee, index) => (
              <Text key={`common-guarantee-${index}`} className="leading-relaxed">
                • {guarantee}
              </Text>
            ))}
          </CollapsibleContent>
        </Collapsible>
      </IconListItem>
    </IconList>
  );
}
